import React from 'react';

export default function TabGroup(props) {
	const { tabs, selectedTab, setTab } = props || {};
	return (
		<div className='tabGroup'>
			{tabs &&
				tabs.map((tab, key) => {
					return (
						<div
							key={key}
							className={`tab${selectedTab === tab.name ? ' selected' : ''}`}
							onClick={() => {
								tab?.onClick();
								setTab(tab.name);
							}}>
							{tab?.text}
						</div>
					);
				})}
		</div>
	);
}
